import axiosInstance from '../../../../../../utils/axios';
import { DateCountDTO } from './models';
import { SalesApiError } from './errors';

const getSales = async (
  token: string,
  timeframe: string = 'TODAY',
): Promise<DateCountDTO[]> => {
  try {
    const response = await axiosInstance.get<DateCountDTO[]>(
      `/v2/admin/full-dashboard/chart/sales`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: {
          timeframe,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    throw new SalesApiError(error.message);
  }
};

export default getSales;
